// extracted by mini-css-extract-plugin
export default {"LeftSideMenu":"LeftSideMenu_LeftSideMenu__ua-we"};